export function parseDate (givenDate) {
  const onlyNumbersArray = givenDate
    .replace(/[^\d]/g, '')
    .split('');

  const parsedDate = onlyNumbersArray
    .reduce((str, char, i) => `${str}${[2, 4].includes(i) ? '/' : ''}${char}`, '');

  if (parsedDate.length > 10) {
    const parsedDate10CharsLong = parsedDate.slice(0, 10);
    return parsedDate10CharsLong;
  }

  return parsedDate;
}

export const isValidDate = (date) => {
  if (!date || date === '') {
    return false;
  }

  const dateRegex = /(0[1-9]|1[012])\/(0[1-9]|[12][0-9]|3[01])\/((19|20)\d\d)/;
  if (!dateRegex.test(date)) {
    return false;
  }

  const [month, day, year] = date.split('/');
  const isLeapYear = (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0));

  const daysInMonth = {
    '01': 31,
    '02': isLeapYear ? 29 : 28,
    '03': 31,
    '04': 30,
    '05': 31,
    '06': 30,
    '07': 31,
    '08': 31,
    '09': 30,
    10: 31,
    11: 30,
    12: 31,
  };

  if (day > daysInMonth[month]) {
    return false;
  }

  return true;
};

export const isoToUsDate = (isoDate) => {
  if (!isoDate) {
    return '';
  }

  const [year, month, day] = isoDate.split('-');
  if (!year || !month || !day) {
    return '';
  }

  return `${month}/${day}/${year}`;
};

export const usDateToIso = (usDate) => {
  if (!usDate) {
    return '';
  }

  const [month, day, year] = usDate.split('/');
  if (!month || !day || !year) {
    return '';
  }

  return `${year}-${month}-${day}`;
};

// Native <input type="date"> can constrain via min/max, but @visibly/vui's Input does not
// forward those attributes to the DOM, so the date-of-birth bounds are enforced here.
export const isValidDateOfBirth = (usDate, { minYear = 1900 } = {}) => {
  if (!isValidDate(usDate)) {
    return false;
  }

  const [month, day, year] = usDate.split('/').map(Number);

  if (year < minYear) {
    return false;
  }

  const dateOfBirth = new Date(year, month - 1, day);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // No future dates of birth (equivalent to max=today).
  return dateOfBirth <= today;
};
